import API from "serviceshift-ui/api-client";

export default {
  fetchServiceCategories({ commit }, include_archived = true) {
    return API.makeRequest(`/v2/service_categories`, {
      method: "GET",
      params: {
        include_archived,
      },
    }).then((res) => {
      commit("replace", {
        state: "serviceCategories",
        data: res.data,
      });
    });
  },
  fetchTaskServiceCategories({ commit }) {
    // Did not add this to API client because this is a temporary hack until we redo quote task picking next sprint
    return API.makeRequest("/v1/service_categories?task_categories=true", {
      method: "GET",
    }).then((res) => {
      commit("replace", {
        state: "serviceCategories",
        data: res.data,
      });
    });
  },
};
